import type { MediaRecord } from '../types'

export const verifiedReferenceMediaBySlug: Record<string, MediaRecord[]> = {
  'rice-root-aphid': [
    {
      id: 'media-rice-root-aphid-cannabis-figure-2',
      url: 'https://oup.silverchair-cdn.com/oup/backfile/Content_public/Journal/jipm/11/1/10.1093_jipm_pmaa008/2/m_pmaa008f0002.jpeg?Expires=2147483647&Key-Pair-Id=APKAIE5G5CRDK6RD3PGA&Signature=EPhu~pO~64p7GWKwLaeesO7JYfmMa8VpG5vqYu3ZxcGNwF4RdNFDEDOKBStsTpzEbph7z24JZxLSMtGslR7jMlrIlILt1UcCGx-Fnyt19QbE7xHClKmKI~qCVKVkjbXTWnBnVEtu9oUVGZdiWWD4SAO9ncgBncMgG1~Qh3cKeT6LT65KkdLoqRRDtwc0UU6riQgTj77ZsnuPdaXALAY5kAPxOwv1fVEZjnWJEcrAw3qygYI3bvDiIg0vF1UfSWUkiufo5KMGNkW1chR9j4IMsHkkoB6tE9ypcaSyRmoYdX5sKbjjeJmarUMy5LQJZGUSSqEQeOD7781Q5oWjw8UsXA__',
      alt: 'Rice root aphids visible at the base and roots of aeroponically grown Cannabis sativa.',
      caption: 'Rice root aphids living on the roots of aeroponically grown Cannabis sativa (Cranshaw and Wainwright-Evans 2020, Figure 2).',
      creator: 'Whitney Cranshaw and Suzanne Wainwright-Evans; figure photographer not separately stated in the caption',
      license: 'CC BY 4.0',
      sourceUrl: 'https://doi.org/10.1093/jipm/pmaa008',
      mediaType: 'image',
      requiredAttribution: 'Cranshaw W, Wainwright-Evans S. 2020. Cannabis sativa as a Host of Rice Root Aphid (Hemiptera: Aphididae) in North America. Journal of Integrated Pest Management 11(1):15. CC BY 4.0.',
      diagnosticLabel: 'rice-root-aphid — Rice root aphid (Rhopalosiphum rufiabdominale) on Cannabis roots',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-only until source-group and panel-level training review are complete.',
        'The presence of rice root aphids is visible; generalized canopy decline is not uniquely diagnostic of this pest.',
        'Do not use this asset to infer root disease, nutrient status, or above-ground symptom severity.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '3fb068bfe723ed06c654bfcc96f990bfabdfa2e976a7770242325c7ae311dea4',
      perceptualHash: 'dhash64:19191b1a4e595b6b',
      width: 520,
      height: 403,
      view: 'root-crown',
      stage: 'all',
      severity: 'moderate',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'fusarium-crown-root-rot': [
    {
      id: 'media-fusarium-cannabis-figure-4',
      url: 'https://www.frontiersin.org/files/Articles/796062/xml-images/fagro-03-796062-g0004.webp',
      alt: 'Multi-panel reference figure showing Fusarium-associated disease signs and pathogen evidence on greenhouse-grown Cannabis plants.',
      caption: 'Infection of greenhouse-grown Cannabis plants by Fusarium species, including yellowing, crown infection and decay, pith necrosis, crown rot, diseased cuttings, flower infection, cultures, and pathogenicity-test symptoms (Gwinn et al. 2022, Figure 4).',
      creator: 'Zamir Punja (photographs), published in Gwinn et al. 2022',
      license: 'CC BY 4.0',
      sourceUrl: 'https://doi.org/10.3389/fagro.2021.796062',
      mediaType: 'image',
      requiredAttribution: 'Gwinn KD, Hansen Z, Kelly H, Ownley BH. 2022. Diseases of Cannabis sativa Caused by Diverse Fusarium Species. Frontiers in Agronomy 3:796062. Figure photographs courtesy of Zamir Punja. CC BY 4.0.',
      diagnosticLabel: 'fusarium-crown-root-rot — Fusarium-associated Cannabis crown/root/wilt disease composite',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Multi-panel and multi-species composite: reference-only as a whole figure.',
        'Do not treat the full composite as one single-class training example.',
        'Do not visually confirm a Fusarium species in an unknown plant from resemblance to this figure.',
        'Use the source article and laboratory confirmation guidance for causal identification.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: 'a02abbebd496081013d34deb188640f3fc134a1ce3b0a77526ddd2babb576ebf',
      perceptualHash: 'dhash64:a7cd13d159c9cfcd',
      width: 1417,
      height: 1748,
      view: 'diagram',
      stage: 'all',
      severity: 'high',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'fusarium-foliar-flower-head-blight': [
    {
      id: 'media-fusarium-flower-bud-figure-1',
      url: 'https://mdpi-res.com/d_attachment/jof/jof-11-00528/article_deploy/html/images/jof-11-00528-g001.png',
      alt: 'Four-panel reference showing natural Fusarium mycelial growth on intact and dried Cannabis inflorescences.',
      caption: 'Natural Fusarium-associated infection of Cannabis inflorescences: pinkish-white growth on intact greenhouse flowers and external or internal growth on dried flowers from the same licensed facility (Punja et al. 2025, Figure 1). Fusarium was confirmed by plant-linked isolation and molecular identification.',
      creator: 'Zamir K. Punja, Sheryl A. Tittlemier, and Sean Walkowiak',
      license: 'CC BY 4.0',
      sourceUrl: 'https://doi.org/10.3390/jof11070528',
      mediaType: 'image',
      requiredAttribution: 'Punja ZK, Tittlemier SA, Walkowiak S. 2025. Fusarium Species Infecting Greenhouse-Grown Cannabis (Cannabis sativa) Plants Show Potential for Mycotoxin Production in Inoculated Inflorescences and from Natural Inoculum Sources. Journal of Fungi 11(7):528. Figure 1. CC BY 4.0.',
      diagnosticLabel: 'fusarium-foliar-flower-head-blight — naturally infected intact and dried Cannabis inflorescence composite reference',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Four-panel composite combining intact greenhouse inflorescences and dried postharvest flowers; reference-only as a whole figure.',
        'The source recovered both Fusarium avenaceum and F. graminearum from Cannabis tissues but does not provide a panel-by-panel species label, so the image cannot train or confirm either species class.',
        'Pinkish-white surface or internal growth overlaps other flower molds and remains insufficient without plant-linked culture and suitable molecular identification.',
        'Do not crop panels into independent examples or infer field progression, prevalence, mycotoxin identity, or mycotoxin concentration from this composite.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '08ab22210fa1a1242a570520352641a4954f0e3ab213f23e3fbb5ddae2e0a6ce',
      perceptualHash: 'dhash64:64cccec5e9c8cccc',
      width: 2058,
      height: 3069,
      view: 'diagram',
      stage: 'flower through postharvest drying',
      severity: 'visible surface and internal colonization',
      confirmation: 'lab-confirmed',
      trainingEligible: false,
    },
  ],
  'cannabis-aphid': [
    {
      id: 'media-cannabis-aphid-figure-2',
      url: 'https://mdpi-res.com/d_attachment/plants/plants-14-00931/article_deploy/html/images/plants-14-00931-g002.png',
      alt: 'Cannabis plants infested with cannabis aphids alongside magnified adult and winged Phorodon cannabis.',
      caption: 'Cannabis plants of the Congo Durban variety infested with Phorodon cannabis, with adult and winged adult aphids shown under a stereo microscope at 20× magnification (Lopez Restrepo and Kovalchuk 2025, Figure 2).',
      creator: 'Daniel Lopez Restrepo and Igor Kovalchuk',
      license: 'CC BY 4.0',
      sourceUrl: 'https://doi.org/10.3390/plants14060931',
      mediaType: 'image',
      requiredAttribution: 'Lopez Restrepo D, Kovalchuk I. 2025. Entomopathogenic Fungi Effectively Control Phorodon cannabis Aphid Population in Cannabis sativa Plants. Plants 14(6):931. CC BY 4.0.',
      diagnosticLabel: 'cannabis-aphid — Phorodon cannabis infestation and adult morphology on Cannabis sativa',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Mixed-scale, multi-panel plant-and-organism figure; reference-only as a whole image.',
        'The two plant panels and two stereo-microscope organism panels do not provide panel-resolved crop geometry or class boundaries.',
        'Do not infer cannabis aphid from yellowing, wilting, or leaf distortion without directly observing aphids or other insect evidence.',
        'Keep training-ineligible until panel-level source grouping, labels, and crop review are complete.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '8b207dc0bc39fbfb7efd8e0356f2a4edeccdcf4028980d1544fc71e753c529d9',
      perceptualHash: 'dhash64:6444daa9ad9b989a',
      width: 1623,
      height: 1724,
      view: 'diagram',
      stage: 'all',
      severity: 'moderate',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'powdery-mildew': [
    {
      id: 'media-powdery-mildew-cannabis-figure-2',
      url: 'https://www.frontiersin.org/files/Articles/720215/xml-images/fagro-03-720215-g0002.webp',
      alt: 'Cannabis powdery mildew experiment comparing a susceptible plant with dense powdery mycelial growth and a resistant phenotype without visible colonies.',
      caption: 'Cannabis powdery mildew resistance experiment showing a susceptible phenotype with dense mycelial growth beside a resistant phenotype without visible powdery mildew colonies (Mihalyov and Garfinkel 2021, Figure 2).',
      creator: 'Paul D. Mihalyov and Andrea R. Garfinkel',
      license: 'CC BY 4.0',
      sourceUrl: 'https://doi.org/10.3389/fagro.2021.720215',
      mediaType: 'image',
      requiredAttribution: 'Mihalyov PD, Garfinkel AR. 2021. Discovery and Genetic Mapping of PM1, a Powdery Mildew Resistance Gene in Cannabis sativa L. Frontiers in Agronomy 3:720215. CC BY 4.0.',
      diagnosticLabel: 'powdery-mildew — Cannabis powdery mildew susceptible/resistant phenotype comparison',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-only phenotype comparison from a controlled disease-resistance experiment.',
        'Dense white mycelial growth can strongly support powdery mildew, but organism identification remains separate when the causal species matters.',
        'Do not use the resistant panel as a negative training control without source-group and experimental-context review.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '7690fd41440735591b9e4562b00fdc58274577cbb3ea38f305f98c27474e6046',
      perceptualHash: 'dhash64:69accecc8edb638e',
      width: 1535,
      height: 1027,
      view: 'whole-plant',
      stage: 'vegetative',
      severity: 'moderate',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'pythium-root-rot': [
    {
      id: 'media-pythium-hemp-pathogenicity-figure-7',
      url: 'https://www.frontiersin.org/files/Articles/706138/xml-images/fagro-03-706138-g0007.webp',
      alt: 'Hemp plants from a controlled pathogenicity trial comparing Pythium, Globisporangium, Fusarium, and uninoculated treatments.',
      caption: "Hemp 'Wife' plants 14 days after inoculation with pathogenic Pythium myriotylum, Globisporangium irregulare, or Fusarium oxysporum isolates, plus the uninoculated control (McGehee and Raudales 2021, Figure 7).",
      creator: 'Cora S. McGehee and Rosa E. Raudales',
      license: 'CC BY 4.0',
      sourceUrl: 'https://doi.org/10.3389/fagro.2021.706138',
      mediaType: 'image',
      requiredAttribution: 'McGehee CS, Raudales RE. 2021. Pathogenicity and Mefenoxam Sensitivity of Pythium, Globisporangium, and Fusarium Isolates From Coconut Coir and Rockwool in Marijuana (Cannabis sativa L.) Production. Frontiers in Agronomy 3:706138. CC BY 4.0.',
      diagnosticLabel: 'pythium-root-rot — controlled hemp root-pathogen pathogenicity comparison including Pythium myriotylum',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Multi-treatment composite containing Pythium, Globisporangium, Fusarium, and uninoculated plants; reference-only until panel boundaries and labels are independently reviewed.',
        "One hemp cultivar and one 14-day whole-plant timepoint are shown; there is no root, crown, lesion-detail, or longitudinal view.",
        'Whole-plant chlorosis, wilt, and growth reduction are not Pythium-specific, and the source study sampled production substrates rather than original marijuana plant tissue.',
        'Do not use the composite to visually confirm Pythium in an unknown plant; plant-linked root or crown evidence and laboratory identification remain required.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '54267dc0fe3eccabaa8f5bd87cae3394beece60a21134bac7d765c0d1817d47b',
      perceptualHash: 'dhash64:e949555123865373',
      width: 2008,
      height: 1501,
      view: 'whole-plant',
      stage: 'vegetative',
      severity: 'high',
      confirmation: 'lab-confirmed',
      trainingEligible: false,
    },
  ],
  'hop-latent-viroid': [
    {
      id: 'media-hlvd-cannabis-figure-1',
      url: 'https://mdpi-res.com/d_attachment/plants/plants-14-00830/article_deploy/html/images/plants-14-00830-g001.png',
      alt: 'Cannabis stock plants shown with molecular HLVd detection results from matched leaf and root samples.',
      caption: 'Cannabis stock plants and HLVd detection results from leaf and root tissues, with HLVd bands confirmed by sequence analysis (Punja et al. 2025, Figure 1).',
      creator: 'Zamir K. Punja, Cameron Scott, Heather H. Tso, Jack Munz, and Liam Buirs; figure photographer not separately stated',
      license: 'CC BY 4.0',
      sourceUrl: 'https://doi.org/10.3390/plants14050830',
      mediaType: 'image',
      requiredAttribution: 'Punja ZK, Scott C, Tso HH, Munz J, Buirs L. 2025. Hop Latent Viroid in Cannabis sativa: Root Distribution and Transmission in Production Systems. Plants 14(5):830. CC BY 4.0.',
      diagnosticLabel: 'hop-latent-viroid — molecularly anchored Cannabis HLVd reference composite',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'HLVd is laboratory-bounded; the image is a molecularly anchored reference, not a visual confirmation tool.',
        'Stunting, small leaves, weak roots, yellowing, and reduced flowering overlap many non-HLVd causes.',
        'Keep the full composite training-ineligible because it mixes plant appearance and molecular-assay panels.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '843e7d7421152fb9cc8a0b35c62610a2a5933367dbe2105ea2edacb2119f90d8',
      perceptualHash: 'dhash64:9e3ab2dad2b8ba9c',
      width: 2262,
      height: 2713,
      view: 'diagram',
      stage: 'all',
      severity: 'moderate',
      confirmation: 'lab-confirmed',
      trainingEligible: false,
    },
    {
      id: 'media-hlvd-osu-positive-hemp-leaves-license-review',
      url: 'https://extension.oregonstate.edu/sites/extd8/files/images/2024-08/picture1.png',
      thumbnailUrl: 'https://extension.oregonstate.edu/sites/extd8/files/styles/full/public/images/2024-08/picture1.png?itok=FiI7MsBJ',
      alt: 'Four-panel composite of detached hemp leaves from Oregon State disease surveys that tested positive for HLVd, showing variable yellow patterning, marginal injury, and generalized chlorosis.',
      caption: 'Metadata-only institutional reference: detached leaves from 2021–2022 Oregon State hemp disease surveys that tested positive for HLVd. The variable and nonspecific appearances cannot confirm HLVd without the linked assay context.',
      creator: 'Cynthia M. Ocamb, Oregon State University Extension Service',
      license: 'Copyright © Oregon State University; no explicit reusable-media license stated on the landing page',
      sourceUrl: 'https://extension.oregonstate.edu/catalog/em-9570-hop-latent-viroid-hemp',
      mediaType: 'image',
      requiredAttribution: 'Cynthia M. Ocamb, Oregon State University Extension Service, 2024. Obtain written permission from Oregon State University before display, copying, modification, or automated training use.',
      diagnosticLabel: 'hop-latent-viroid — assay-positive detached hemp leaf symptom diversity, license review',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-link metadata only; no image file is stored in the repository.',
        'Do not display, copy, modify, or use for automated training without documented permission.',
        'Detached leaves omit plant architecture, canopy position, timing, root condition, and cultivar context.',
        'The leaves tested positive for HLVd, but positive status does not prove every visible lesion, color, or margin pattern was caused by HLVd.',
      ],
      displayPermission: 'unknown',
      reviewStatus: 'license-review',
      trainingPermission: 'not-permitted',
      sha256: '3d23e038ae781b11da3fd0da810738b555f2d8dda47119df172aadc23fccd8d5',
      perceptualHash: 'dhash64:3635352b2bad6969',
      width: 2147,
      height: 537,
      view: 'diagram',
      stage: 'field survey, detached leaves',
      severity: 'variable symptomatic leaves',
      confirmation: 'lab-confirmed',
      trainingEligible: false,
    },
    {
      id: 'media-hlvd-osu-hemp-field-progression-license-review',
      url: 'https://extension.oregonstate.edu/sites/extd8/files/images/2024-08/screenshot-2024-08-22-071358.png',
      thumbnailUrl: 'https://extension.oregonstate.edu/sites/extd8/files/styles/full/public/images/2024-08/screenshot-2024-08-22-071358.png?itok=ZZcwpsOJ',
      alt: 'Two-panel Oregon field-hemp composite labeled A and B and described by Oregon State as early and later-stage HLVd symptoms.',
      caption: 'Metadata-only institutional reference: field hemp in the Hermiston, Oregon area shown at early (A) and later (B) symptom stages attributed to HLVd by Oregon State Extension. Low resolution and unstated reuse rights prevent display and training use.',
      creator: 'K. Frost, Oregon State University Extension Service',
      license: 'Copyright © Oregon State University; no explicit reusable-media license stated on the landing page',
      sourceUrl: 'https://extension.oregonstate.edu/catalog/em-9570-hop-latent-viroid-hemp',
      mediaType: 'image',
      requiredAttribution: 'K. Frost, Oregon State University Extension Service, 2024. Obtain written permission from Oregon State University before display, copying, modification, or automated training use.',
      diagnosticLabel: 'hop-latent-viroid — institutional hemp field early/later symptom context, license review',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-link metadata only; no image file is stored in the repository.',
        'Do not display, copy, modify, or use for automated training without documented permission.',
        'The two-panel image is low resolution and does not provide a controlled same-plant time series or visible molecular-assay panel.',
        'Use the institutional caption as field context only; do not infer HLVd from plant stature, leaf color, or canopy form in an unknown field plant.',
      ],
      displayPermission: 'unknown',
      reviewStatus: 'license-review',
      trainingPermission: 'not-permitted',
      sha256: 'beca7fdd70ffff5f28a8e0397c301aafac1be21b79381fd26de49c0fd36764b6',
      perceptualHash: 'dhash64:af185b5327e53571',
      width: 548,
      height: 237,
      view: 'diagram',
      stage: 'field growth, early and later symptom context',
      severity: 'institutional early/later comparison',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'beet-curly-top-virus': [
    {
      id: 'media-bctv-cannabis-figure-19',
      url: 'https://mdpi-res.com/d_attachment/ijms/ijms-25-00014/article_deploy/html/images/ijms-25-00014-g019.png',
      alt: 'Indoor- and outdoor-grown Cannabis plants with genotype-dependent Beet curly top virus symptoms that were confirmed by molecular diagnostics.',
      caption: 'Indoor- and outdoor-grown Cannabis plants with symptoms attributed to Beet curly top virus across multiple genotypes; BCTV presence was confirmed by RT-PCR (Punja et al. 2024, Figure 19).',
      creator: 'Zamir K. Punja, Dieter Kahl, Ron Reade, Yu Xiang, Jack Munz, and Punya Nachappa; visualization credited to Zamir K. Punja',
      license: 'CC BY 4.0',
      sourceUrl: 'https://doi.org/10.3390/ijms25010014',
      mediaType: 'image',
      requiredAttribution: 'Punja ZK, Kahl D, Reade R, Xiang Y, Munz J, Nachappa P. 2024. Challenges to Cannabis sativa Production from Pathogens and Microbes—The Role of Molecular Diagnostics and Bioinformatics. International Journal of Molecular Sciences 25(1):14. CC BY 4.0.',
      diagnosticLabel: 'beet-curly-top-virus — RT-PCR-confirmed Cannabis BCTV symptom composite',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'BCTV is laboratory-bounded and the visible syndrome varies among Cannabis genotypes.',
        'Do not identify BCTV from leaf curl, stunting, mosaic/discoloration, or distorted growth alone.',
        'Keep the full composite training-ineligible because it contains multiple genotypes and symptom presentations.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '25decd9424d09359794823ac2357bb6b13e99d9f34247f4f1acfca6016343e90',
      perceptualHash: 'dhash64:1c9892b2985a7ab3',
      width: 2686,
      height: 1811,
      view: 'diagram',
      stage: 'all',
      severity: 'high',
      confirmation: 'lab-confirmed',
      trainingEligible: false,
    },
  ],
}
